import { graphql, HttpResponse } from 'msw'
import { type EnrollmentHYCSManualReviewData, type EnrollmentHYCSManualReviewSubmitOutput } from '../../../../models'

export const getEnrollmentHYCSManualReviewDataMock: EnrollmentHYCSManualReviewData = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/hycs/manual-review',
  enrollmentData: {
    applicationId: '1234567890',
  },
}

export const submitEnrollmentHYCSManualReviewDataMock: EnrollmentHYCSManualReviewSubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  // path: '/enrollment/hycs/step-2',
}

export const mockGetEnrollmentHYCSManualReviewData = graphql.mutation('getEnrollmentHYCSManualReviewData', () => {
  return HttpResponse.json({ data: { submitEnrollment: getEnrollmentHYCSManualReviewDataMock } })
})

export const mockSubmitEnrollmentHYCSManualReviewData = graphql.mutation('submitEnrollmentHYCSManualReviewData', () => {
  return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentHYCSManualReviewDataMock } })
})

export const mockEnrollmentHYCSManualReview = [
  mockGetEnrollmentHYCSManualReviewData,
  mockSubmitEnrollmentHYCSManualReviewData,
]
